import CXMApiClient from "../../CXMApiClient";

import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {
    CanPushToFinance: []
  };
}

const state = initialState();

const getters = {
  CanPushToFinance: function(state) {
    return state.CanPushToFinance;
  }
};

const actions = {
  canPushToFinance: function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    return new Promise((resolve, reject) => {
      let cxmApiClient = new CXMApiClient();
      cxmApiClient
        .ProcessRequest(
          "POST",
          "/api/push_to_dms/push_to_f_and_i/is_valid",
          request,
          scope
        )
        .then(resp => {
          if (resp.data && resp.data.successful) {
            let data = resp.data.data;
            data.accountPlatformId = request.accountPlatformId;
            context.commit("updateCanPushToFinanceSingle", data);
            resolve(resp);
          } else reject(resp);
        })
        .catch(resp => {
          reject(resp);
        });
    });
  },
  canPushToFinanceMultiStore: async function(context, request) {
    let client = new CXMApiClient();
    let response = await client.ProcessRequest(
      "POST",
      "/api/push_to_dms/push_to_f_and_i/is_valid_list",
      request
    );
    if (response.data && response.data.successful) {
      context.commit("updateCanPushToFinance", response.data.data);
    }
  }
};

const mutations = {
  updateCanPushToFinance: function(state, data) {
    state.CanPushToFinance = data;
  },
  updateCanPushToFinanceSingle: function(state, data) {
    state.CanPushToFinance.push(data);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/FinancePush/FinancePush.js